import { render, staticRenderFns } from "./CodingRequestNew.vue?vue&type=template&id=681a3bba&scoped=true&"
import script from "./CodingRequestNew.vue?vue&type=script&lang=js&"
export * from "./CodingRequestNew.vue?vue&type=script&lang=js&"
import style0 from "./CodingRequestNew.vue?vue&type=style&index=0&id=681a3bba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a3bba",
  null
  
)

export default component.exports